import React, { useRef, useState } from 'react';

export default function TiltCard({ children, className = '', glowColor = '#003366' }) {
  const ref = useRef(null);
  const [style, setStyle] = useState({});

  const handleMove = (e) => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width;
    const y = (e.clientY - rect.top) / rect.height;
    const rotateX = (0.5 - y) * 12;
    const rotateY = (x - 0.5) * 12;
    setStyle({
      transform: `perspective(600px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.02, 1.02, 1.02)`,
      boxShadow: `${(x - 0.5) * 20}px ${(y - 0.5) * 20}px 40px -10px ${glowColor}22`,
    });
  };

  const handleLeave = () => {
    setStyle({ transform: 'perspective(600px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)', boxShadow: '' });
  };

  return (
    <div
      ref={ref}
      onMouseMove={handleMove}
      onMouseLeave={handleLeave}
      className={`transition-[box-shadow] duration-300 ${className}`}
      style={{ ...style, transition: 'transform 0.2s ease-out, box-shadow 0.3s ease-out', willChange: 'transform' }}
    >
      {children}
    </div>
  );
}
